import { atom, useRecoilValue, selectorFamily, selector } from 'recoil'
import { getRequest } from '/src/httpClient'
import { isBrowser } from '/src/util'

export const getCart = async () => {
  const response = await getRequest('/api/cart', new AbortController())

  if (response) {
    const [cart] = response
    return cart ? cart : false
  }

  return null
}

/*export const cartState = atom({
  key: 'cartState',
  default: null,
  effects: [
    async ({setSelf}) => {
      if (!isBrowser) return
      setSelf(await getCart())
    }
  ]
})*/


export const cartState = atom({
  key: 'cartState',
  default: selector({
    key: 'cartState/default',
    get: () => {
      if (!isBrowser) return null

      return getCart()
    }
  })
})

export const cartCountState = atom({
  key: 'cartCountState',
  default: null
})

export const cartCountQuery = selectorFamily({
  key: 'cartCountQuery',
  get: () => ({get}) => {
    if (!isBrowser) return null

    const cart = get(cartState)
    if (!cart) return false

    const { order_items } = cart.relationships
    return order_items.data.map(({ attributes }) => {
      return attributes.quantity
    }).reduce(
      (a, c) => a + parseInt(c),
      0
    )
  },
})

export const cartCountSelector = selector({
  key: 'cartCountSelector',
  get: ({ get }) => {
    if (!isBrowser) return null
    return get(cartCountQuery(get(cartCountState)))
  }
})

export const useCartCount = () => {
  return useRecoilValue(cartCountSelector)
}

export const useCart = () => {
  return useRecoilValue(cartState)
}
